import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";

import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NgChanges } from "@app/shared/model/ng-changes.model";

@Component({
    selector: "app-log-filter-badget",
    templateUrl: "./log-filter-badget.component.html",
    styleUrls: ["./log-filter-badget.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogFilterBadgetComponent implements OnChanges {
    @Input() listFilter: Record<string, { key: string; label: string }> = {};
    @Output() removeFilter = new EventEmitter<string>();

    filterArr: { key: string; label: string }[] = [];
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        matIconRegistry.addSvgIcon("xclose", domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/xclose.svg`));
    }
    ngOnChanges(changes: NgChanges<LogFilterBadgetComponent>): void {
        if (changes.listFilter) {
            this.filterArr = Object.values(changes.listFilter.currentValue);
        }
    }

    onRemoveFilter(key: string) {
        this.removeFilter.emit(key);
    }
}
